const idPrefix = {
    current: ''
}, getIDPrefix = ()=>idPrefix.current;

const hasExt = (path)=>{
    const lastDotIndex = path?.split('/').pop()?.lastIndexOf('.');
    return (lastDotIndex ?? 0) > 1 && path && path.length - 1 > (lastDotIndex ?? 0);
};
/**
 * Exported functions.
 */ const floatEqual = (a, b)=>Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b)), floatZero = (f)=>Math.abs(f) <= 0.00001, createElementID = (()=>{
    let _count = 0;
    return ()=>{
        _count++;
        return `${getIDPrefix()}__lottie_element_${_count}`;
    };
})(), clamp = (n, minFromProps = 0, maxFromProps = 100)=>{
    let min = minFromProps, max = maxFromProps;
    if (min > max) {
        const mm = max;
        max = min;
        min = mm;
    }
    return Math.min(Math.max(n, min), max);
}, /**
   * Download file, either SVG or dotLottie.
   */ download = (data, options)=>{
    const blob = new Blob([
        data
    ], {
        type: options?.mimeType
    }), fileName = options?.name || createElementID(), dataURL = URL.createObjectURL(blob), link = document.createElement('a');
    link.href = dataURL;
    link.download = fileName;
    link.hidden = true;
    document.body.appendChild(link);
    link.click();
    setTimeout(()=>{
        link.remove();
        URL.revokeObjectURL(dataURL);
    }, 1000);
}, getExt = (str)=>{
    if (typeof str !== 'string' || !str || !hasExt(str)) {
        return;
    }
    return str.split('.').pop()?.toLowerCase();
}, getExtFromB64 = (str)=>{
    const mime = str.split(':')[1].split(';')[0], ext = mime.split('/')[1].split('+')[0];
    return ext;
}, /**
     * Parse URL to get filename.
     *
     * @param src - The url string.
     * @param keepExt - Whether to include file extension.
     * @returns Filename, in lowercase.
     */ getFilename = (src, keepExt)=>{
    // Because the regex strips all special characters, we need to extract the file extension, so we can add it later if we need it
    let ext = getExt(src);
    ext = ext ? `.${ext}` : undefined;
    return `${src.split('/').pop()?.replace(/\.[^.]*$/, '').replaceAll(/\W+/g, '-')}${keepExt && ext ? ext : ''}`;
}, addExt = (ext, str)=>{
    if (!str) {
        return;
    }
    if (getExt(str)) {
        if (getExt(str) === ext) {
            return str;
        }
        return `${getFilename(str)}.${ext}`;
    }
    return `${str}.${ext}`;
}, isAudio = (asset)=>!('h' in asset) && !('w' in asset) && 'p' in asset && 'e' in asset && 'u' in asset && 'id' in asset, isImage = (asset)=>'w' in asset && 'h' in asset && !('xt' in asset) && 'p' in asset, parseBase64 = (str)=>str.slice(Math.max(0, str.indexOf(',') + 1));

var ArrayType = /*#__PURE__*/ function(ArrayType) {
    ArrayType["Float32"] = "float32";
    ArrayType["Int16"] = "int16";
    ArrayType["Int32"] = "int32";
    ArrayType["Uint8"] = "uint8";
    ArrayType["Uint8c"] = "uint8c";
    return ArrayType;
}({});
var PlayMode = /*#__PURE__*/ function(PlayMode) {
    PlayMode["Bounce"] = "bounce";
    PlayMode["Normal"] = "normal";
    return PlayMode;
}({});
var PlayerEvents = /*#__PURE__*/ function(PlayerEvents) {
    PlayerEvents["Complete"] = "complete";
    PlayerEvents["Destroyed"] = "destroyed";
    PlayerEvents["Error"] = "error";
    PlayerEvents["Frame"] = "frame";
    PlayerEvents["Freeze"] = "freeze";
    PlayerEvents["Load"] = "load";
    PlayerEvents["Loop"] = "loop";
    PlayerEvents["Next"] = "next";
    PlayerEvents["Pause"] = "pause";
    PlayerEvents["Play"] = "play";
    PlayerEvents["Previous"] = "previous";
    PlayerEvents["Ready"] = "ready";
    PlayerEvents["Rendered"] = "rendered";
    PlayerEvents["Stop"] = "stop";
    return PlayerEvents;
}({});
var PreserveAspectRatio = /*#__PURE__*/ function(PreserveAspectRatio) {
    PreserveAspectRatio["Contain"] = "xMidYMid meet";
    PreserveAspectRatio["Cover"] = "xMidYMid slice";
    PreserveAspectRatio["Initial"] = "none";
    PreserveAspectRatio["None"] = "xMinYMin slice";
    return PreserveAspectRatio;
}({});
var RendererType = /*#__PURE__*/ function(RendererType) {
    RendererType["Canvas"] = "canvas";
    RendererType["HTML"] = "html";
    RendererType["SVG"] = "svg";
    return RendererType;
}({});
var ShapeType = /*#__PURE__*/ function(ShapeType) {
    ShapeType["Ellipse"] = "el";
    ShapeType["Fill"] = "fl";
    ShapeType["GradientFill"] = "gf";
    ShapeType["GradientStroke"] = "gs";
    ShapeType["Group"] = "gr";
    ShapeType["Merge"] = "mm";
    ShapeType["NoStyle"] = "no";
    ShapeType["OffsetPath"] = "op";
    ShapeType["Path"] = "sh";
    ShapeType["PolygonStar"] = "sr";
    ShapeType["PuckerBloat"] = "pb";
    ShapeType["Rectangle"] = "rc";
    ShapeType["Repeater"] = "rp";
    ShapeType["RoundedCorners"] = "rd";
    ShapeType["Stroke"] = "st";
    ShapeType["Transform"] = "tr";
    ShapeType["Trim"] = "tm";
    ShapeType["Twist"] = "tw";
    ShapeType["Unknown"] = "ms";
    ShapeType["ZigZag"] = "zz";
    return ShapeType;
}({});

const degToRads = Math.PI / 180, namespaceSVG = 'http://www.w3.org/2000/svg', _isServer = ()=>!(typeof window !== 'undefined' && document), isServer = _isServer(), _inBrowser = ()=>typeof navigator !== 'undefined', inBrowser = _inBrowser(), _isSafari = ()=>{
    const isTrue = inBrowser ? /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) : false;
    return isTrue;
}, isSafari = _isSafari();

export { ArrayType, PlayMode, PlayerEvents, PreserveAspectRatio, RendererType, ShapeType, addExt, clamp, createElementID, degToRads, download, floatEqual, floatZero, getExt, getExtFromB64, getFilename, inBrowser, isAudio, isImage, isSafari, isServer, namespaceSVG, parseBase64 };
